<template>
    <div>Konfigurasjon for {{ csvFormat }}</div>
    <div class="p-4 border rounded-lg border-default mb-4">
        <div class="import-config-ap-grid">
            <div>
                <span class="text-xs">Oppgjør</span>
                <account-picker v-model:account-no="config.debitAccount" :accounts="bookkeepingAccounts" placeholder="Oppgjør"/>
            </div>
            <div>
                <span class="text-xs">Gebyr</span>
                <account-picker v-model:account-no="config.feesAccount" :accounts="bookkeepingAccounts" placeholder="Gebyr"/>
            </div>
            <div>
                <span class="text-xs">Bank</span>
                <account-picker v-model:account-no="config.fundsAccount" :accounts="bookkeepingAccounts" placeholder="Innbetaling"/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import {CsvFormats, ImportAccountConfiguration} from '@/csv-transaction-importer/csv-import.service'
import {PropType} from 'vue'
import {bookkeepingAccounts} from '@/bookkeeping-account/bookkeepingAccount.service'
import AccountPicker from '@/account-picker/AccountPicker.vue'

defineProps({
    csvFormat: {
        type: String as PropType<CsvFormats>,
        required: true
    }
})

const config = defineModel<ImportAccountConfiguration>({required: true})

</script>

<style scoped>
.import-config-ap-grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

}

</style>